import { LateralPanelService } from './lateral-panel.service';
import { Component, OnInit, OnDestroy, ElementRef, Input, ViewChild, ContentChild, Output, EventEmitter } from '@angular/core';
import { trigger, transition, animate, style, AnimationEvent, state } from '@angular/animations';

@Component({
  selector: 'app-lateral-panel',
  templateUrl: './lateral-panel.component.html',
  styleUrls: ['./lateral-panel.component.scss', './lateral-panel.component.responsive.scss'],
  animations: [
    trigger('inOutAnimation', [
			transition(':enter', [
				style({ transform: 'translateX(100%)', opacity: 0 }),
				animate('500ms ease-out', style({ transform: 'translateX(0)', opacity: 1 }))
			]),
			transition(':leave', [
				style({ transform: 'translateX(0)', opacity: 1 }),
				animate('500ms ease-in', style({ transform: 'translateX(100%)', opacity: 0 }))
			])
		])
  ]
})
export class LateralPanelComponent implements OnInit, OnDestroy {
  @Input() id: string;
  @Input() extraClasses: string;

  show: boolean = false;
  @Input() showSidebar: boolean = false;
  @Output() showSidebarChange: EventEmitter<boolean> = new EventEmitter();
  private element: any;

  constructor(
    private lps: LateralPanelService,
    private el: ElementRef,
  ) {
    this.element = el.nativeElement;
  }

  ngOnInit() {
    if (!this.id) {
      console.error('modal must have an id');
      return;
    }
    this.lps.add(this);
  }

  ngOnDestroy() {
    this.lps.remove(this.id);
    this.element.remove();
  }

  open(): void {
    this.show = true;
    this.showSidebar = true;
    this.showSidebarChange.emit(this.showSidebar);
  }

  onCloseTooltip() {
    this.showSidebar = false;
  }

  animationDone(event: AnimationEvent) {
    if (event.fromState === null && event.toState === 'void') {
      this.show = false;
    }
  }

}
